export default {
  Withdrawals: 'Withdrawals',
  pending: 'Pending',
  accepted: 'Accepted',
  rejected: 'Rejected',
  denied: 'Denied',
  withdrawableRevenue: 'Withdrawable Revenue',
  addNewWithdrawal: 'Add New Withdrawal'
};
